"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StatusFetcher = void 0;

var tslib_1 = require("tslib");

var Errors_1 = require("@skbkontur/plugin-js/lib/common/Errors");

var Log_1 = require("@skbkontur/plugin-js/lib/common/Log");

var Plugin_1 = require("@skbkontur/plugin-js/lib/Plugin");

var constants_1 = require("../../utils/constants");

var Storage_1 = require("../../utils/Storage");

var Errors_2 = require("../Errors");

var StatusFetcher =
/** @class */
function () {
  function StatusFetcher(options) {
    var _this = this;

    this.options = options;
    this.active = false;
    this.completed = false;
    this.thumbprints = [];
    this.currentStatusMap = {};
    this.timeoutId = 0;
    this.iterationIndex = 0;
    this.storage = new Storage_1.Storage();
    this.errorCount = 0;
    this.log = Log_1.LogManager.getLog(constants_1.LOG_PREFIX + "StatusFetcher");
    /**
     * Задаем массив отпечатков, для которых будут запрашиваться статусы.
     * @param certificateInfos: ICertificateInfo[]
     * @return void
     */

    this.setCertificateInfos = function (certListItem) {
      _this.thumbprints = certListItem.filter(function (item) {
        if ([Plugin_1.StoreType.Requisite, Plugin_1.StoreType.CACabinet].includes(item.storeInfo.type)) {
          return false;
        }

        if (_this.options.issuers.length) {
          return _this.options.issuers.includes(item.certificate.issuer());
        } else {
          return true; // #emptyCabucIssuers
        }
      }).map(function (item) {
        return item.certificate.thumbprint();
      });
    };

    this.start = function () {
      _this.log.info('Start status fetching');

      _this.active = true;

      _this.fetchIteration();
    };

    this.stop = function () {
      _this.log.info('Stop status fetching');

      clearTimeout(_this.timeoutId);
      _this.active = false;
      _this.iterationIndex = 0;
    };

    this.isActive = function () {
      return _this.active;
    };

    this.isCompleted = function () {
      return _this.completed;
    };
    /**
     * Возвращает IStatusMap для текушего массива отпечатков сертификатов this.thumbprints.
     */


    this.getStatusMap = function () {
      return _this.currentStatusMap;
    };

    this.hasStatuses = function () {
      return Object.keys(_this.currentStatusMap).length !== 0;
    };

    this.fetchIteration = function () {
      return tslib_1.__awaiter(_this, void 0, void 0, function () {
        var newStatusMap;

        var _this = this;

        return tslib_1.__generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              if (!this.active) {
                return [2
                /*return*/
                ];
              }

              if (!this.thumbprints.length) return [3
              /*break*/
              , 2];
              this.log.info("Cabuc status fetching iteration #" + this.iterationIndex++);
              return [4
              /*yield*/
              , this.fetchStatuses()];

            case 1:
              newStatusMap = _a.sent();

              if (!this.active) {
                return [2
                /*return*/
                ];
              }

              this.setStatusMap(newStatusMap);
              return [3
              /*break*/
              , 3];

            case 2:
              this.log.info('Skipped cabuc status fetching. No thumbprints.');
              _a.label = 3;

            case 3:
              return [4
              /*yield*/
              , this.options.onIterationComplete(this.getStatusMap())];

            case 4:
              _a.sent();

              this.timeoutId = window.setTimeout(function () {
                _this.fetchIteration();
              }, this.options.fetchPeriod);
              return [2
              /*return*/
              ];
          }
        });
      });
    };

    this.arStatusToMap = function (statuses) {
      return statuses // проверяем наличие отпечатков в статусах
      .filter(function (status) {
        return status.Thumbprint.length;
      }) // и переводим отпечатки в нижний регистр
      .map(function (status) {
        return tslib_1.__assign(tslib_1.__assign({}, status), {
          Thumbprint: status.Thumbprint.toLowerCase()
        });
      }).reduce(function (previousValue, currentStatusInfo) {
        var _a;

        return tslib_1.__assign(tslib_1.__assign({}, previousValue), (_a = {}, _a[currentStatusInfo.Thumbprint] = currentStatusInfo, _a));
      }, {});
    };

    this.fetchStatuses = function () {
      return tslib_1.__awaiter(_this, void 0, void 0, function () {
        var thumbprints, tempCabucStatuses, _getStatusHelper, statuses, error_1;

        var _this = this;

        return tslib_1.__generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              thumbprints = tslib_1.__spreadArrays(this.thumbprints);
              tempCabucStatuses = [];

              _getStatusHelper = function getStatusHelper(thumbprintsPart) {
                return tslib_1.__awaiter(_this, void 0, void 0, function () {
                  var cabucStatusesPart, error_2;
                  return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                      case 0:
                        _a.trys.push([0, 2,, 3]);

                        return [4
                        /*yield*/
                        , this.options.getStatus(thumbprintsPart)];

                      case 1:
                        cabucStatusesPart = _a.sent();

                        if (!Array.isArray(cabucStatusesPart)) {
                          throw new Errors_1.CommonError("Wrong response format");
                        }

                        tempCabucStatuses = tempCabucStatuses.concat(cabucStatusesPart);
                        return [3
                        /*break*/
                        , 3];

                      case 2:
                        error_2 = _a.sent();
                        this.log.error('Cabuc status getting error', error_2.message, error_2);
                        this.options.trackEvent('status', 'error', {
                          errorCode: error_2.code || 'unknownError',
                          errorMessage: error_2.message
                        });
                        this.errorCount++;

                        if (this.errorCount >= this.options.maxErrorCount) {
                          throw new Errors_1.CommonError('Cabuc status max error count exceeded', null, Errors_2.ErrorCodes.CabucStatusMaxErrorCountExceeded);
                        }

                        return [3
                        /*break*/
                        , 3];

                      case 3:
                        return [2
                        /*return*/
                        , thumbprints.length ? _getStatusHelper(thumbprints.splice(0, this.options.thumbprintPerRequest)) : tempCabucStatuses];
                    }
                  });
                });
              };

              _a.label = 1;

            case 1:
              _a.trys.push([1, 3,, 4]);

              return [4
              /*yield*/
              , _getStatusHelper(thumbprints.splice(0, this.options.thumbprintPerRequest))];

            case 2:
              statuses = _a.sent();
              return [2
              /*return*/
              , this.arStatusToMap(statuses)];

            case 3:
              error_1 = _a.sent(); // Если при получении статусов происходят ошибки, значит нужно остановить дальнейшие запросы.

              this.completed = true;
              this.log.error(error_1.message, error_1);
              this.stop();
              return [2
              /*return*/
              , {}];

            case 4:
              return [2
              /*return*/
              ];
          }
        });
      });
    };

    this.setStatusMap = function (newStatusMap) {
      _this.currentStatusMap = newStatusMap;

      _this.log.info('Received new statuses for thumbprint', _this.currentStatusMap);

      if (_this.options.useCachedStatus && Object.keys(_this.currentStatusMap).length) {
        _this.storage.saveStatuses(_this.currentStatusMap);
      }
    };

    if (options.useCachedStatus) {
      this.currentStatusMap = this.storage.getStatuses();
    }
  }

  return StatusFetcher;
}();

exports.StatusFetcher = StatusFetcher;